import { keyBy } from 'lodash';
import { Observable, map, toArray } from 'rxjs';
import type { OperatorFunction } from 'rxjs';

import { log } from './logging';

let subscription = 0;

export function logged<T>(name: string) {
  return (source: Observable<T>): Observable<T> => {
    const prefix = `${name} ${subscription++}`;

    log(prefix, 'subscribed');
    return new Observable<T>((subscriber) => {
      let completed = false;

      const subscription = source.subscribe({
        next: (item) => {
          log(prefix, 'new item', item);
          subscriber.next(item);
        },
        error: (error) => {
          log(prefix, 'error', error);
          completed = true;
          subscriber.error(error);
        },
        complete: () => {
          log(prefix, 'completed');
          completed = true;
          subscriber.complete();
        },
      });

      return (): void => {
        if (!completed) {
          log(prefix, 'cancelled');
        }

        log(prefix, 'disposed');
        subscription.unsubscribe();
      };
    });
  };
}

export function toDictionary<T>(
  keySelector: (item: T) => string
): OperatorFunction<T, Record<string, T>> {
  return (source: Observable<T>) =>
    source.pipe(
      toArray(),
      map((array: T[]) => keyBy(array, keySelector))
    );
}
